<template>
    <client-page class="app--main">
        <!-- S: sub-visual -->
        <section class="sub-visual">
            <v-container>
                <div class="tit-wrap mb-24 mb-md-50 mb-lg-0">
                    <v-img class="tit-wrap__img" src="/images/common/tit-img.png"></v-img>
                    <h2 class="tit tit--xl">
                        Company
                    </h2>
                </div>
            </v-container>
            <v-img class="sub-visual__img" src="/images/sub/company/sub-visual-company.jpg"></v-img>
            <sub-tab page="회사소개" :tabActive="4"></sub-tab>
        </section>
        <!-- E: sub-visual -->

        <!-- S: contact -->
        <section class="sub-section sub-section--contact">
            <v-container>
                <v-card flat class="h-300px h-lg-500px">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.1213528284475!2d127.22307098860779!3d37.52863656001022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357cb23ba131d1cf%3A0x426f880eb3cef2dd!2z6rK96riw64-EIO2VmOuCqOyLnCDssL3smrDroZwgMzgtMzU!5e0!3m2!1sko!2skr!4v1687430444070!5m2!1sko!2skr" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </v-card>

                <div class="mt-30 mt-md-44 mt-md-60">
                    <v-row no-gutters align="center">
                        <v-col cols="12" md="6" xl="3">
                            <div class="list-wrap border-xl-end" data-aos="fade-up">
                                <v-img class="mr-24" min-width="40" max-width="48" aspect-ratio="1/1" contain src="/images/sub/company/contact/address.png"></v-img>
                                <div>
                                    <div class="tit-wrap tit-wrap--xs">
                                        <h3 class="tit tit--sm">
                                            Address
                                        </h3>
                                    </div>
                                    <p class="page-text grey--text">
                                        경기도 하남시 창우로 38-35번지
                                    </p>
                                </div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="6" xl="3">
                            <div class="list-wrap list-wrap--center border-xl-end" data-aos="fade-up" data-aos-delay="100">
                                <v-img class="mr-24" min-width="40" max-width="48" aspect-ratio="1/1" contain src="/images/sub/company/contact/tel.png"></v-img>
                                <div>
                                    <div class="tit-wrap tit-wrap--xs">
                                        <h3 class="tit tit--sm">
                                            Tel
                                        </h3>
                                    </div>
                                    <p class="page-text grey--text">
                                        02-487-7350
                                    </p>
                                </div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="6" xl="3">
                            <div class="list-wrap list-wrap--center border-xl-end" data-aos="fade-up" data-aos-delay="200">
                                <v-img class="mr-24" min-width="40" max-width="48" aspect-ratio="1/1" contain src="/images/sub/company/contact/fax.png"></v-img>
                                <div>
                                    <div class="tit-wrap tit-wrap--xs">
                                        <h3 class="tit tit--sm">
                                            Fax
                                        </h3>
                                    </div>
                                    <p class="page-text grey--text">
                                        02-486-2189
                                    </p>
                                </div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                            <div class="list-wrap list-wrap--end" data-aos="fade-up" data-aos-delay="300">
                                <v-img class="mr-24" min-width="40" max-width="48" aspect-ratio="1/1" contain src="/images/sub/company/contact/e-mail.png"></v-img>
                                <div>
                                    <div class="tit-wrap tit-wrap--xs">
                                        <h3 class="tit tit--sm">
                                            E-mail
                                        </h3>
                                    </div>
                                    <p class="page-text grey--text">
                                        MODOO456@naver.com
                                    </p>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>
        <!-- S: contact -->
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubTab from "@/components/client/sub/sub-tab.vue";
// import BoardList from "@/components/client/board/board-list.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";
import Swiper from "swiper/bundle";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

export default {
    components: {
        ClientPage,
        SubTab,
        // BoardList,
        PopupLayer,
        LocaleSelect,
        IconArrowRounded,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        categoriesYoutube,
        categoriesReport,
        categoriesForms,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.Swiper = new Swiper(".products-slide .swiper-container", {
                    slidesPerView: 1,
                    spaceBetween: 120,
                    speed: 1000,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        // pc
                        768: {
                            slidesPerView: 2,
                        },
                    },
                });
            });
        },
    },
};
</script>
